module.exports = __webpack_public_path__ + "5d47d4c6441fa9fc8296e083a5b46bdf.pdf";